// Components
import { Popup, Table, TableFilter } from '../../components';
import { ViewDownloadStatus } from '../../components';

import {
    MAKER_CHECKER_EVENT_TYPES,
    MAKER_CHECKER_EVENT_TYPES_MLE,
    MAKER_CHECKER_EVENT_TYPES_TITLE_MAP,
    MERCHANT_STATUS_MAP,
    MOCK_API_VALUE,
} from '../../utils/constants/commonValues';

import CheckerView from './CheckerView';

// Actions

// Libraries
import {
    fetchCheckerRequest,
    showLoader,
    hideLoader,
    generateCheckerReportRequest,
    generateReportError,
    getActiveCheckerReportRequest,
    downloadCheckerReportRequest,
    getStaticDataRequestChecker
} from './redux/checker.actions';

import React, { useMemo, useCallback, useState, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import moment from 'moment';

import './checker.scss';
import MleRequestedApprovalView from './MleRequestedApprovalView';
import { checkEventTypeExist } from './checker.utils';
import { MLE_ONBOARDING } from './checker.constants';
import DownloadFile from './DownloadFile';
import { replaceUnderscoresWithSpaces } from 'utils/helperMethods';

const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment().subtract(1, 'days'),
            endDate: moment(),
            maximumNights: 31,
            notResetDate: true,
        },
    },
    {
        fieldType: 'radio',
        label: 'Sort By',
        name: 'rangeType',
        props: {
            options: [
                { name: 'Created', value: 'created_on' },
                { name: 'Updated', value: 'updated_on' }
            ],
            labelField: 'name',
            valueField: 'value',
        }
    },
    {
        fieldType: 'select',
        label: 'Event Type',
        name: 'eventType',
        props: {
            data: [],
            label: 'Select Event Type',
            labelField: 'label',
            valueField: 'value',
        },
    },
    {
        fieldType: 'input',
        label: 'Unique ID/Merchant ID',
        name: 'idempotencyId',
        props: {
            placeholder: 'Enter Unique ID/Merchant ID',
        },
    },
    {
        fieldType: 'input',
        label: 'Maker Id',
        name: 'makerId',
        props: {
            placeholder: 'Enter Unique Maker ID',
        },
    },
    {
        fieldType: 'select',
        label: 'Status',
        name: 'status',
        props: {
            data: [],
            label: 'Select Status',
            labelField: 'status',
            valueField: 'value',
        },
    },
    // {
    //     fieldType: 'select',
    //     label: 'Onboarding Type',
    //     name: 'source',
    //     props: {
    //         placeholder: 'Select Onboarding Type',
    //         data: [
    //             { name: 'Axis Sourced Merchant', value: 'axis' },
    //             { name: 'Others', value: 'other' },
    //         ],
    //         label: 'Select Onboarding Type',
    //         labelField: 'name',
    //         valueField: 'value',
    //     },
    // },
    {
        fieldType: 'input',
        label: 'Registered Email',
        name: 'registeredEmail',
        props: {
            placeholder: 'Enter Email',
        },
    },
    {
        fieldType: 'input',
        label: 'Mobile',
        name: 'mobile',
        props: {
            placeholder: 'Enter Mobile Number',
        },
    }
];

const setMerchantFilter = (fieldsList, underlyingMerchant, userLevel, statusOptions) => {
    fieldsList.forEach(element => {
        if (element.name === 'eventType') {
            element.props.data = Object.entries(MAKER_CHECKER_EVENT_TYPES).map(
                ([label, value]) => ({
                    label: replaceUnderscoresWithSpaces(label),
                    value,  
                })
            );
        }
    });


    fieldsList.forEach(element => {
        if (element.name === 'status') {
            element.props.data = Object.entries(statusOptions).map(
                ([key, value]) => ({
                    status: value.name,
                    value: key
                })
            );
        }
    });

    if (underlyingMerchant.length && userLevel && userLevel !== 'MERCHANT') {
        fieldsList.forEach(element => {
            if (element.name === 'merchantId') {
                element.props.data = underlyingMerchant;
            }
        });
        return fieldsList;
    }

    return fieldsList.filter(item => item.name !== 'merchantId');
};

const CheckerActions = ({ data, handleOpenActionPopup, setSelectedData, history }) => {
    const originalData = data.original;
    const makerRequestId = originalData.makerRequestId;


    const handleOnClick = () => {

        if (originalData?.eventType === MLE_ONBOARDING || originalData?.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.business_update) {
            history.push(`/checker/business_detail_section/${makerRequestId}`);
        } else if (originalData?.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update) {
            history.push(`/checker/ownership_detail_section/${makerRequestId}`);
        } else {
            setSelectedData(originalData);
            handleOpenActionPopup(true);
        }
    };

    return (
        <div className="userAction  multiItem">
            <button className={`view`} id={originalData?.idempotencyId || ''} onClick={handleOnClick} />
        </div>
    );
};

const Checker = ({ actions, checkerData, auth, staticData }) => {
    const { tableData, isLoading, pagination, error } = checkerData;

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filterData, setFilterData] = useState({});
    const [isResetPage, setIsResetPage] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    const [selectedData, setSelectedData] = useState(false);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const { activeReports, generatedFile } = checkerData || {};
    const [showFilter, setShowFilter] = useState(false);
    const [statusOptions, setStatusOptions] = useState([]);
    const [filters, setFilters] = useState([]);

    useEffect(() => {
        actions.getStaticDataRequestChecker({ screenType: 'REQUESTED_APPROVALS' });
    }, [actions]);

    useEffect(() => {
        if (checkerData?.staticData?.data?.makerCheckerStatusMap) {
            setStatusOptions(checkerData?.staticData?.data?.makerCheckerStatusMap);
        }
    }, [checkerData?.staticData?.data?.makerCheckerStatusMap]);

    const history = useHistory();

    const handleCloseView = () => {
        setShowPopUp(false);
        fetchData({
            pageSize,
            pageIndex,
        });
    };

    const handleViewOpen = () => {
        setShowPopUp(true);
    };

    const handleCloseViewDownloads = () => {
        setShowFilter(false);
    };

    const handleViewDownloads = () => {
        setShowFilter(true);
    };

    useEffect(() => {
        if (generatedFile.isSuccess) {
            setShowFilter(true);
            setShowDownloadPopup(false);
        }
        return () => {
            actions.generateReportError({ error: {} });
        };
    }, [actions, generatedFile.isSuccess]);    

    const { underlyingMerchant } = staticData;
    useEffect(() => {
        const hasStatusOptions = statusOptions && Object.keys(statusOptions).length > 0;
        if (hasStatusOptions && filterFieldList && underlyingMerchant) {
            const filters = setMerchantFilter(filterFieldList, underlyingMerchant, undefined, statusOptions);
            setFilters(filters);
        }
    }, [filterFieldList, underlyingMerchant, statusOptions]);

    const fetchData = useCallback(
        (pageSize, pageIndex) => {
            const data = {
                pageSize: pageSize.pageSize,
                pageIndex: pageSize.pageIndex,
            };
            const payload = { ...data, ...filterData };
            actions.fetchCheckerRequest(payload);

            setPageSize(pageSize.pageSize);
            setPageIndex(pageSize.pageIndex);
        },
        [actions, filterData]
    );

    const fetchFilterData = filterValues => {
        setFilterData(filterValues);
        setIsResetPage(true);
    };

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const columns = useMemo(
        () => [
            { header: 'Event Type', accessor: 'eventTypeName' },
            { header: 'Unique Id', accessor: 'idempotencyId' },
            { header: 'Created At', accessor: 'createdAt' },
            { header: 'Updated At', accessor: 'updatedAt' },
            { header: 'Maker Request ID', accessor: 'makerRequestId' },
            { header: 'Maker Id', accessor: 'makerId' },
            { header: 'Status', accessor: 'status' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const getTableData = useCallback(() => {
        return tableData.map(item => ({ ...item,
            eventTypeName: item.eventType === 'KYC' ? 'MERCHANT DOCS' : item.eventType.split('_').join(' '),
        }));
    }, [tableData]);

    return (
        <>
            <div className="checker-wrapper">
                <Table
                    tableTitle="Merchant Checker"
                    onClickTableAction={handleViewDownloads || handleViewOpen}
                    columns={columns}
                    data={getTableData()}
                    filterActionTitle="View Downloads"
                    isFiltersEnable
                    filterData={filterData}
                    tableFilters={
                        <TableFilter
                            showOverlay
                            customFilterClass="rightSkewed"
                            fieldsList={filters}
                            filterData={filterData}
                            onSubmit={filterValues => {
                                const tempFilterValue = { ...filterValues };
                                fetchFilterData(tempFilterValue);
                            }}
                            onReset={resetValue => {
                                setFilterData(resetValue);
                                setIsResetPage(true);
                            }}
                        />
                    }
                    tableActionPopup={
                        <>
                            {showFilter && (
                                <Popup
                                    title="Download Status"
                                    showCloseIcon
                                    showOverlay
                                    showFilter={showFilter}
                                    closePopup={handleCloseViewDownloads}
                                >
                                    <ViewDownloadStatus pageType={'Checker'} reportType={'REQUESTED_APPROVAL'} actions={actions} data={activeReports?.reports || ''} />
                                </Popup>
                            )}

                            {showPopUp && (
                                <Popup
                                    title={MAKER_CHECKER_EVENT_TYPES_TITLE_MAP[selectedData.eventType]}
                                    showCloseIcon
                                    showOverlay
                                    showFilter={showPopUp}
                                    closePopup={handleCloseView}
                                    type="LARGE"
                                >
                                    <CheckerView
                                        data={selectedData}
                                        closePopup={handleCloseView}
                                        showLoader={actions.showLoader}
                                        hideLoader={actions.hideLoader}
                                    />
                                </Popup>
                            )}
                        </>
                    }              
                    additionalActions={() => {
                        return (
                            <DownloadFile
                                filterData={filterData}
                                tableData={tableData}
                                actions={actions}
                                showDownloadPopup={showDownloadPopup}
                                setShowDownloadPopup={setShowDownloadPopup}
                                generateData={generatedFile}
                            />
                        );
                    }}
                    userActions={data => {
                        // return (
                        //     history.push('/checker/BUSINESS_DETAILS/3755')
                        //     // history.push(`${data.original.eventType}/${data.original.makerRequestId}`)
                        // )

                        return (
                            <CheckerActions
                                data={data}
                                handleOpenActionPopup={handleViewOpen}
                                setSelectedData={setSelectedData}
                                history={history}
                            />
                        );
                    }}
                    isPaginationEnable
                    loading={isLoading}
                    error={error && error.errorMessage}
                    fetchData={fetchData}
                    numberOfRecord={pagination.totalNumberOfRecords}
                    paginationLabel="Rows per page"
                    pageSizeOptions={pageSizeOptions}
                    pagePerView={3}
                    pageCount={pageCount}
                    isResetPage={isResetPage}
                    afterResetPage={() => setIsResetPage(false)}
                />
            </div>
        </>
    );
};

CheckerActions.propTypes = {
    data: PropTypes.object,
    downloadRequest: PropTypes.func,
    handleOpenActionPopup: PropTypes.func,
    setSelectedData: PropTypes.func,
};

Checker.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    manageBin: PropTypes.object,
    loader: PropTypes.object,
    checkerData: PropTypes.object,
    staticData: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    loader,
    actions,
    checkerData,
    staticData,
}) => ({
    auth,
    loader,
    actions,
    checkerData,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchCheckerRequest,
            generateCheckerReportRequest,
            generateReportError,
            getActiveCheckerReportRequest,
            downloadCheckerReportRequest,
            getStaticDataRequestChecker,
            showLoader,
            hideLoader 
        },
        dispatch
    ),
});
export default connect(mapStateToProps, mapDispatchToProps)(Checker);
